import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import BodyView from "@/layout/bodyView.vue"
import auth from "@/components/commen/block/auth/authView.vue"
import login from "@/components/commen/block/auth/loginPage.vue"

import indexDefault from "@/pages/dashboards/indexDefault.vue"
import indexCrm from "@/pages/dashboards/indexCrm.vue"
import indexGeneral from "@/pages/widgets/indexGeneral.vue"
import indexCharts from "@/pages/widgets/indexCharts.vue"
import indexTypography from "@/pages/uikits/indexTypography.vue"
import indexAvatars from "@/pages/uikits/indexAvatars.vue"
import indexHelper from "@/pages/uikits/indexHelper.vue"
import indexGrid from "@/pages/uikits/indexGrid.vue"
import indexTagPills from "@/pages/uikits/indexTagPills.vue"
import indexProgress from "@/pages/uikits/indexProgress.vue"
import indexModal from "@/pages/uikits/indexModal.vue"
import indexAlert from "@/pages/uikits/indexAlert.vue"
import indexPopover from "@/pages/uikits/indexPopover.vue"
import indexTooltip from "@/pages/uikits/indexTooltip.vue"
import indexDropdown from "@/pages/uikits/indexDropdown.vue"
import indexAccordion from "@/pages/uikits/indexAccordion.vue"
import indexTabs from "@/pages/uikits/indexTabs.vue"
import indexLists from "@/pages/uikits/indexLists.vue"
import indexAnimate from "@/pages/animation/indexAnimate.vue"
import indexAos from "@/pages/animation/indexAos.vue"
import indexScrollable from "@/pages/advance/indexScrollable.vue"
import indexTree from "@/pages/advance/indexTree.vue"
import indexToasts from "@/pages/advance/indexToasts.vue"
import indexRating from "@/pages/advance/indexRating.vue"
import indexDropzone from "@/pages/advance/indexDropzone.vue"
import indexTour from "@/pages/advance/indexTour.vue"
import indexSweetalert from "@/pages/advance/indexSweetalert.vue"
import animationModal from "@/pages/advance/animationModal.vue"
import owlCarousel from "@/pages/advance/owlCarousel.vue"
import indexRibbon from "@/pages/advance/indexRibbon.vue"
import indexPagenation from "@/pages/advance/indexPagenation.vue"
import indexBreadcrumb from "@/pages/advance/indexBreadcrumb.vue"
import indexRange from "@/pages/advance/indexRange.vue"
import indexCropper from "@/pages/advance/indexCropper.vue"
import indexBasiccard from "@/pages/advance/indexBasiccard.vue"
import indexCreative from "@/pages/advance/indexCreative.vue"
import indexDraggable from "@/pages/advance/indexDraggable.vue"
import indexTimeline from "@/pages/advance/indexTimeline.vue"
import indexFlag from "@/pages/icons/indexFlag.vue"
import indexFontawesome from "@/pages/icons/indexFontawesome.vue"
import indexIcoicon from "@/pages/icons/indexIcoicon.vue"
import indexThemify from "@/pages/icons/indexThemify.vue"
import indexFeather from "@/pages/icons/indexFeather.vue"
import indexWhether from "@/pages/icons/indexWhether.vue"
import indexDefaultStyle from "@/pages/buttons/indexDefault.vue"
import indexFlat from "@/pages/buttons/indexFlat.vue"
import indexEdge from "@/pages/buttons/indexEdge.vue"
import indexRaised from "@/pages/buttons/indexRaised.vue"
import indexGroup from "@/pages/buttons/indexGroup.vue"
import indexValidation from "@/pages/forms/formcontrols/indexValidation.vue"
import indexInputs from "@/pages/forms/formcontrols/indexInputs.vue"
import indexCheckbox from "@/pages/forms/formcontrols/indexCheckbox.vue"
import indexGroups from "@/pages/forms/formcontrols/indexGroups.vue"
import indexMask from "@/pages/forms/formcontrols/indexMask.vue"
import indexMega from "@/pages/forms/formcontrols/indexMega.vue"
import indexDatapicker from "@/pages/forms/formwidgets/indexDatapicker.vue"
import indexTouchspin from "@/pages/forms/formwidgets/indexTouchspin.vue"
import indexSwitch from "@/pages/forms/formwidgets/indexSwitch.vue"
import indexTypeahead from "@/pages/forms/formwidgets/indexTypeahead.vue"
import indexClipboard from "@/pages/forms/formwidgets/indexClipboard.vue"
import formWizard2 from "@/pages/forms/formlayout/formWizard2.vue"
import indexTwofactor from "@/pages/forms/formlayout/indexTwofactor.vue"
import formWizard from "@/pages/forms/formlayout/formWizard.vue"
import indexBootstrap from "@/pages/table/indexBootstrap.vue"
import indexComponent from "@/pages/table/indexComponent.vue"
import indexInit from "@/pages/table/indexInit.vue"
import indexApexchart from "@/pages/charts/indexApexchart.vue"
import indexGoogle from "@/pages/charts/indexGoogle.vue"
import indexChartist from "@/pages/charts/indexChartist.vue"
import projectList from "@/pages/project/projectList.vue"
import createProject from "@/pages/project/createProject.vue"
import fileManager from "@/pages/filemaneger/fileManager.vue"
import kanbanBoard from "@/pages/kanban/kanbanBoard.vue"
import indexBookmark from "@/pages/bookmark/indexBookmark.vue"
import indexContact from "@/pages/contacts/indexContact.vue"
import indexTodo from "@/pages/todo/indexTodo.vue"
import indexSearch from "@/pages/search/indexSearch.vue"
import indexCalendar from "@/pages/calendar/indexCalendar.vue"
import indexTask from "@/pages/task/indexTask.vue"
import indexChat from "@/pages/chat/indexChat.vue"
import indexVideo from "@/pages/chat/indexVideo.vue"
import indexProfile from "@/pages/user/indexProfile.vue"
import indexEdit from "@/pages/user/indexEdit.vue"
import indexCard from "@/pages/user/indexCard.vue"
import indexProduct from "@/pages/ecommerce/indexProduct.vue"
import indexCart from "@/pages/ecommerce/indexCart.vue"
import indexSoical from "@/pages/socialapp/indexSoical.vue"
import indexProductlist from "@/pages/ecommerce/indexProductlist.vue"
import paymentDetail from "@/pages/ecommerce/paymentDetail.vue"
import indexInvoice from "@/pages/ecommerce/indexInvoice.vue"
import indexWishlist from "@/pages/ecommerce/indexWishlist.vue"
import indexCheckout from "@/pages/ecommerce/indexCheckout.vue"
import indexPricing from "@/pages/ecommerce/indexPricing.vue"
import productPage from "@/pages/ecommerce/productPage.vue"
import indexSample from "@/pages/samplepage/indexSample.vue"
import indexInternationalization from "@/pages/internationalization/indexInternationalization.vue"
import indexGallery from "@/pages/gallery/indexGallery.vue"
import indexGriddesc from "@/pages/gallery/indexGriddesc.vue"
import indexMasonry from "@/pages/gallery/indexMasonry.vue"
import indexMasonarydesc from "@/pages/gallery/indexMasonarydesc.vue"
import hoverGallery from "@/pages/gallery/hoverGallery.vue"
import indexDetails from "@/pages/blog/indexDetails.vue"
import indexSingle from "@/pages/blog/indexSingle.vue"
import indexAdd from "@/pages/blog/indexAdd.vue"
import indexFaq from "@/pages/faq/indexFaq.vue"
import jobCard from "@/pages/job/indexCard.vue"
import indexJobdetails from "@/pages/job/indexDetails.vue"
import indexList from "@/pages/job/indexList.vue"
import indexApply from "@/pages/job/indexApply.vue"
import indexLearning from "@/pages/learning/indexLearning.vue"
import indexCourse from "@/pages/learning/indexCourse.vue"
import indexGooglemap from "@/pages/maps/indexGoogle.vue"
import indexLeaflet from "@/pages/maps/indexLeaflet.vue"
import indexCk from "@/pages/editor/indexCk.vue"
import simpleEditor from "@/pages/editor/simpleEditor.vue"
import indexKnowledgebase from "@/pages/knowledgebase/indexKnowledgebase.vue"
import indexSupport from "@/pages/support/indexSupport.vue"
import errorPage1 from "@/pages/error/errorPage1.vue"
import errorPage2 from "@/pages/error/errorPage2.vue"
import errorPage3 from "@/pages/error/errorPage3.vue"
import errorPage4 from "@/pages/error/errorPage4.vue"
import errorPage5 from "@/pages/error/errorPage5.vue"
import errorPage6 from "@/pages/error/errorPage6.vue"
import comingsoonPage from "@/pages/comingsoon/comingsoonPage.vue"
import comingsoonVideo from "@/pages/comingsoon/comingsoonVideo.vue"
import comingsoonImage from "@/pages/comingsoon/comingsoonImage.vue"
import loginSimple from "@/pages/authentication/loginSimple.vue"
import loginImage from "@/pages/authentication/loginImage.vue"
import loginImagetwo from "@/pages/authentication/loginImagetwo.vue"
import loginValidation from "@/pages/authentication/loginValidation.vue"
import loginTooltip from "@/pages/authentication/loginTooltip.vue"
import loginSweetalert from "@/pages/authentication/loginSweetalert.vue"
import registerSimple from "@/pages/authentication/registerSimple.vue"
import registerImage from "@/pages/authentication/registerImage.vue"
import registerImagetwo from "@/pages/authentication/registerImagetwo.vue"
import unlockUser from "@/pages/authentication/unlockUser.vue"
import forgetPassword from "@/pages/authentication/forgetPassword.vue"
import resetPassword from "@/pages/authentication/resetPassword.vue"
import maintenanceView from "@/pages/authentication/maintenanceView.vue"
import indexEmailapp from "@/pages/email/indexEmailapp.vue"
import indexCompose from "@/pages/email/indexCompose.vue"
import indexOrder from "@/pages/ecommerce/indexOrder.vue"
import indexSelect from "@/pages/forms/formwidgets/indexSelect.vue"

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: BodyView,
    meta: {
      title: 'Default | Coin - Premium Admin Template',
    },
    children: [
      {
        path: '',
        name: 'defaultRoot',
        component: indexDefault,
        meta: {
          title: 'Default | Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/auth",
    component: auth,
    children: [
      {
        path: "login",
        name: "login",
        component: login
      }
    ]
  },
  {
    path: "/dashboards",
    component: BodyView,
    children: [
      {
        path: "dashboard_default",
        name: "default",
        component: indexDefault,
        meta: {
          title: 'Dashboards Default | Coin - Premium Admin Template',
        }
      },
      {
        path: "crm_dashboard",
        name: "crm",
        component: indexCrm,
        meta: {
          title: 'Dashboards CRM | Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/widgets",
    component: BodyView,
    children: [
      {
        path: "general",
        name: "General",
        component: indexGeneral,
        meta: {
          title: 'Widgets General | Coin - Premium Admin Template',
        }
      },
      {
        path: "Chart",
        name: "charts",
        component: indexCharts,
        meta: {
          title: 'Widgets Chart | Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/uikits",
    component: BodyView,
    children: [
      {
        path: "typography",
        name: "Typography",
        component: indexTypography,
        meta: {
          title: 'Uikits Typography | Coin - Premium Admin Template',
        }
      },
      {
        path: "avatars",
        name: "Avatars",
        component: indexAvatars,
        meta: {
          title: 'Uikits Avatars | Coin - Premium Admin Template',
        }
      },
      {
        path: "helper_classes",
        name: "Helper",
        component: indexHelper,
        meta: {
          title: 'Uikits Helper Classes | Coin - Premium Admin Template',
        }
      },
      {
        path: "grid",
        name: "Grid",
        component: indexGrid,
        meta: {
          title: 'Uikits Grid | Coin - Premium Admin Template',
        }
      },
      {
        path: "tag_pills",
        name: "TagPills",
        component: indexTagPills,
        meta: {
          title: 'Uikits Tag & Pills | Coin - Premium Admin Template',
        }
      },
      {
        path: "progress_bar",
        name: "Progress",
        component: indexProgress,
        meta: {
          title: 'Uikits Progressbar | Coin - Premium Admin Template',
        }
      },
      {
        path: "modal",
        name: "model",
        component: indexModal,
        meta: {
          title: 'Uikits Modal | Coin - Premium Admin Template',
        }
      },
      {
        path: "alert",
        name: "alert",
        component: indexAlert,
        meta: {
          title: 'Uikits Alert | Coin - Premium Admin Template',
        }
      },
      {
        path: "popover",
        name: "popover",
        component: indexPopover,
        meta: {
          title: 'Uikits popover | Coin - Premium Admin Template',
        }
      },
      {
        path: "tooltip",
        name: "tooltip",
        component: indexTooltip,
        meta: {
          title: 'Uikits Tooltip | Coin - Premium Admin Template',
        }
      },
      {
        path: "dropdown",
        name: "Dropdown",
        component: indexDropdown,
        meta: {
          title: 'Uikits Dropdown | Coin - Premium Admin Template',
        }
      },
      {
        path: "accordion",
        name: "Accordion",
        component: indexAccordion,
        meta: {
          title: 'Uikits Accordion | Coin - Premium Admin Template',
        }
      },
      {
        path: "tabs",
        name: "Tabs",
        component: indexTabs,
        meta: {
          title: 'Uikits Tabs | Coin - Premium Admin Template',
        }
      },
      {
        path: "lists",
        name: "lists",
        component: indexLists,
        meta: {
          title: 'Uikits Lists | Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/animation",
    component: BodyView,
    children: [
      {
        path: "animate",
        name: "animate",
        component: indexAnimate,
        meta: {
          title: 'Animate | Coin - Premium Admin Template',
        }
      },
      {
        path: "aos_animation",
        name: "aos",
        component: indexAos,
        meta: {
          title: 'Aos Animation | Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/advance",
    component: BodyView,
    children: [
      {
        path: "scrollable",
        name: "Scrollable",
        component: indexScrollable,
        meta: {
          title: 'Bonus UI  Scrollable | Coin - Premium Admin Template',
        }
      },
      {
        path: "tree",
        name: "tree",
        component: indexTree,
        meta: {
          title: 'Bonus UI  Tree | Coin - Premium Admin Template',
        }
      },
      {
        path: "toasts",
        name: "Toasts",
        component: indexToasts,
        meta: {
          title: 'Bonus UI  Toasts | Coin - Premium Admin Template',
        }
      },
      {
        path: "rating",
        name: "rating",
        component: indexRating,
        meta: {
          title: 'Bonus UI  Rating | Coin - Premium Admin Template',
        }
      },
      {
        path: "dropzone",
        name: "Dropzone",
        component: indexDropzone,
        meta: {
          title: 'Bonus UI  Dropzone | Coin - Premium Admin Template',
        }
      },
      {
        path: "tour",
        name: "tour",
        component: indexTour,
        meta: {
          title: 'Bonus UI  Tour | Coin - Premium Admin Template',
        }
      },
      {
        path: "sweetalert",
        name: "sweetalert",
        component: indexSweetalert,
        meta: {
          title: 'Bonus UI  SweetAlert | Coin - Premium Admin Template',
        }
      },
      {
        path: "animated_modal",
        name: "animationModal",
        component: animationModal,
        meta: {
          title: 'Bonus UI  Animated Modal | Coin - Premium Admin Template',
        }
      },
      {
        path: "owl_carousel",
        name: "owlCarousel",
        component: owlCarousel,
        meta: {
          title: 'Bonus UI  Owl Carousel | Coin - Premium Admin Template',
        }
      },
      {
        path: "ribbons",
        name: "ribbon",
        component: indexRibbon,
        meta: {
          title: 'Bonus UI  Ribbons | Coin - Premium Admin Template',
        }
      },
      {
        path: "pagination",
        name: "pagenation",
        component: indexPagenation,
        meta: {
          title: 'Bonus UI  Pagenation | Coin - Premium Admin Template',
        }
      },
      {
        path: "breadcrumb",
        name: "Breadcrumb",
        component: indexBreadcrumb,
        meta: {
          title: 'Bonus UI  Breadcrumb | Coin - Premium Admin Template',
        }
      },
      {
        path: "range_slider",
        name: "Range",
        component: indexRange,
        meta: {
          title: 'Bonus UI  Range | Coin - Premium Admin Template',
        }
      },
      {
        path: "image_cropper",
        name: "imageCropper",
        component: indexCropper,
        meta: {
          title: 'Bonus UI  imageCropper | Coin - Premium Admin Template',
        }
      },
      {
        path: "basic_card",
        name: "Basiccard",
        component: indexBasiccard,
        meta: {
          title: 'Bonus UI  Basic Card | Coin - Premium Admin Template',
        }
      },
      {
        path: "creative_card",
        name: "Creative",
        component: indexCreative,
        meta: {
          title: 'Bonus UI  Creative Card | Coin - Premium Admin Template',
        }
      },
      {
        path: "draggable_card",
        name: "Draggable",
        component: indexDraggable,
        meta: {
          title: 'Bonus UI  Draggable Card | Coin - Premium Admin Template',
        }
      },
      {
        path: "timeline",
        name: "indexTimeline",
        component: indexTimeline,
        meta: {
          title: 'Bonus UI  Timeline | Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/icons",
    component: BodyView,
    children: [
      {
        path: "flag",
        name: "flag",
        component: indexFlag,
        meta: {
          title: 'Icons Flag | Coin - Premium Admin Template',
        }
      },
      {
        path: "fontawesome",
        name: "Fontawesome",
        component: indexFontawesome,
        meta: {
          title: 'Icons Fontawesome | Coin - Premium Admin Template',
        }
      },
      {
        path: "themify",
        name: "Themify",
        component: indexThemify,
        meta: {
          title: 'Icons Themify | Coin - Premium Admin Template',
        }
      },
      {
        path: "feather_icon",
        name: "Feather",
        component: indexFeather,
        meta: {
          title: 'Icons Feather | Coin - Premium Admin Template',
        }
      },
      {
        path: "whether",
        name: "indexWether",
        component: indexWhether,
        meta: {
          title: 'Icons Whether | Coin - Premium Admin Template',
        }
      },
      {
        path: "ico",
        name: "Icoicon",
        component: indexIcoicon,
        meta: {
          title: 'Icons Icoicon | Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/buttons",
    component: BodyView,
    children: [
      {
        path: "default_button",
        name: "button",
        component: indexDefaultStyle,
        meta: {
          title: 'Buttons Default | Coin - Premium Admin Template',
        }
      },
      {
        path: "flat",
        name: "Flat",
        component: indexFlat,
        meta: {
          title: 'Buttons Flat | Coin - Premium Admin Template',
        }
      },
      {
        path: "edge",
        name: "Edge",
        component: indexEdge,
        meta: {
          title: 'Buttons Edge | Coin - Premium Admin Template',
        }
      },
      {
        path: "raised",
        name: "Raised",
        component: indexRaised,
        meta: {
          title: 'Buttons Raised | Coin - Premium Admin Template',
        }
      },
      {
        path: "group",
        name: "Group",
        component: indexGroup,
        meta: {
          title: 'Buttons Group | Coin - Premium Admin Template',
        }
      },

    ]
  },
  {
    path: "/form",
    component: BodyView,
    children: [
      {
        path: "validation",
        name: "formValidation",
        component: indexValidation,
        meta: {
          title: 'Form Controls Form Validation| Coin - Premium Admin Template',
        }
      },
      {
        path: "base_inputs",
        name: "indexInputs",
        component: indexInputs,
        meta: {
          title: 'Form Controls Base Input| Coin - Premium Admin Template',
        }
      },
      {
        path: "checkbox_radio",
        name: "indexCheckbox",
        component: indexCheckbox,
        meta: {
          title: 'Form Controls Checkbox & Radio| Coin - Premium Admin Template',
        }
      },
      {
        path: "select2",
        name: "Select",
        component: indexSelect,
        meta: {
          title: 'Form Widgets Select| Coin - Premium Admin Template',
        }
      },
      {
        path: "input_groups",
        name: "indexGroups",
        component: indexGroups,
        meta: {
          title: 'Form Controls Input Groups| Coin - Premium Admin Template',
        }
      },
      {
        path: "input_mask",
        name: "indexMask",
        component: indexMask,
        meta: {
          title: 'Form Controls Input Mask| Coin - Premium Admin Template',
        }
      },
      {
        path: "mega_options",
        name: "indexMega",
        component: indexMega,
        meta: {
          title: 'Form Controls Mega Options| Coin - Premium Admin Template',
        }
      },
      {
        path: "datepicker",
        name: "datapicker",
        component: indexDatapicker,
        meta: {
          title: 'Form Widgets Datepicker| Coin - Premium Admin Template',
        }
      },
      {
        path: "touchspin",
        name: "indexTouchspin",
        component: indexTouchspin,
        meta: {
          title: 'Form Widgets Touchspin| Coin - Premium Admin Template',
        }
      },
      {
        path: "switch",
        name: "indexSwitch",
        component: indexSwitch,
        meta: {
          title: 'Form Widgets Switch| Coin - Premium Admin Template',
        }
      },
      {
        path: "typeahead",
        name: "indexTypeahead",
        component: indexTypeahead,
        meta: {
          title: 'Form Widgets Typeahead| Coin - Premium Admin Template',
        }
      },
      {
        path: "clipboard",
        name: "indexClipboard",
        component: indexClipboard,
        meta: {
          title: 'Form Widgets Clipboard| Coin - Premium Admin Template',
        }
      },
      {
        path: "form_wizard_two",
        name: "formWizardtwo",
        component: formWizard2,
        meta: {
          title: 'Form Layout Form Wizard 2| Coin - Premium Admin Template',
        }
      },
      {
        path: "two_actor",
        name: "Two Factor",
        component: indexTwofactor,
        meta: {
          title: 'Form Layout Two Factor| Coin - Premium Admin Template',
        }
      },
      {
        path: "form_wizard",
        name: "formWizard",
        component: formWizard,
        meta: {
          title: 'Form Layout Form Wizard 2| Coin - Premium Admin Template',
        }
      },
    ]
  },
  {
    path: "/table",
    component: BodyView,
    children: [
      {
        path: "basic",
        name: "bootstrp",
        component: indexBootstrap,
        meta: {
          title: 'Table Bootstrap Table| Coin - Premium Admin Template',
        }
      },
      {
        path: "table_components",
        name: "tablecomponent",
        component: indexComponent,
        meta: {
          title: 'Table Table Components| Coin - Premium Admin Template',
        }
      },
      {
        path: "datatable_basic",
        name: "basicinit",
        component: indexInit,
        meta: {
          title: 'Table Basic Init| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/chart",
    component: BodyView,
    children: [
      {
        path: "apexChart",
        name: "Apexchart",
        component: indexApexchart,
        meta: {
          title: 'Chart Apex Chart| Coin - Premium Admin Template',
        }
      },
      {
        path: "google",
        name: "google",
        component: indexGoogle,
        meta: {
          title: 'Chart Google Chart| Coin - Premium Admin Template',
        }
      },
      {
        path: "chartist",
        name: "chartist",
        component: indexChartist,
        meta: {
          title: 'Chart Chartist Chart| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/project",
    component: BodyView,
    children: [
      {
        path: "project_list",
        name: "projectList",
        component: projectList,
        meta: {
          title: 'Project List| Coin - Premium Admin Template',
        }
      },
      {
        path: "project_create",
        name: "createProject",
        component: createProject,
        meta: {
          title: 'Create Project| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/app",
    component: BodyView,
    children: [
      {
        path: "file_manager",
        name: "fileManager",
        component: fileManager,
        meta: {
          title: 'File Manager| Coin - Premium Admin Template',
        }
      },
      {
        path: "kanban_board",
        name: "kanbanBoard",
        component: kanbanBoard,
        meta: {
          title: 'kanban Board| Coin - Premium Admin Template',
        }
      },
      {
        path: "chat",
        name: "Chatapp",
        component: indexChat,
        meta: {
          title: 'Chat App| Coin - Premium Admin Template',
        }
      },
      {
        path: "video_chat",
        name: "videochat",
        component: indexVideo,
        meta: {
          title: 'Chat Video| Coin - Premium Admin Template',
        }
      },
      {
        path: "bookmark",
        name: "bookmark",
        component: indexBookmark,
        meta: {
          title: 'Bookmark| Coin - Premium Admin Template',
        }
      },
      {
        path: "contact",
        name: "contacts",
        component: indexContact,
        meta: {
          title: 'contact| Coin - Premium Admin Template',
        }
      },
      {
        path: "todo",
        name: "todo",
        component: indexTodo,
        meta: {
          title: 'To Do| Coin - Premium Admin Template',
        }
      },
      {
        path: "task",
        name: "task",
        component: indexTask,
        meta: {
          title: 'Task| Coin - Premium Admin Template',
        }
      },
      {
        path: "calendar",
        name: "calendar",
        component: indexCalendar,
        meta: {
          title: 'Calendar| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/pages",
    component: BodyView,
    children: [
      {
        path: "social_app",
        name: "socialapp",
        component: indexSoical,
        meta: {
          title: 'Social App| Coin - Premium Admin Template',
        }
      },
      {
        path: "search",
        name: "searchresult",
        component: indexSearch,
        meta: {
          title: 'Search| Coin - Premium Admin Template',
        }
      },
      {
        path: "sample_page",
        name: "samplepage",
        component: indexSample,
        meta: {
          title: 'Simple Page| Coin - Premium Admin Template',
        }
      },
      {
        path: "internationalization",
        name: "Internationalization",
        component: indexInternationalization,
        meta: {
          title: 'Internationalization| Coin - Premium Admin Template',
        }
      },
      {
        path: "faq",
        name: "faq",
        component: indexFaq,
        meta: {
          title: 'Faq| Coin - Premium Admin Template',
        }
      },
      {
        path: "support",
        name: "Support",
        component: indexSupport,
        meta: {
          title: 'Support| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/users",
    component: BodyView,
    children: [
      {
        path: "profile",
        name: "userProfile",
        component: indexProfile,
        meta: {
          title: 'User Profile| Coin - Premium Admin Template',
        }
      },
      {
        path: "edit",
        name: "indexEdit",
        component: indexEdit,
        meta: {
          title: 'User Edit| Coin - Premium Admin Template',
        }
      },
      {
        path: "cards",
        name: "usercard",
        component: indexCard,
        meta: {
          title: 'User Cards| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/ecommerce",
    component: BodyView,
    children: [
      {
        path: "product",
        name: "product",
        component: indexProduct,
        meta: {
          title: 'Product | Coin - Premium Admin Template',
        }
      },
      {
        path: "cart",
        name: "cart",
        component: indexCart,
        meta: {
          title: 'Cart | Coin - Premium Admin Template',
        }
      },
      {
        path: "details/:id",
        name: "productPage",
        component: productPage,
        meta: {
          title: 'Product Page | Coin - Premium Admin Template',
        }
      },

      {
        path: "payment_details",
        name: "paymentDetail",
        component: paymentDetail,
        meta: {
          title: 'Payment Detail | Coin - Premium Admin Template',
        }
      },
      {
        path: "invoice",
        name: "Invoice",
        component: indexInvoice,
        meta: {
          title: 'Invoice | Coin - Premium Admin Template',
        }
      },
      {
        path: "checkout",
        name: "Checkout",
        component: indexCheckout,
        meta: {
          title: 'Checkout | Coin - Premium Admin Template',
        }
      },
      {
        path: "pricing",
        name: "pricing",
        component: indexPricing,
        meta: {
          title: 'Pricing | Coin - Premium Admin Template',
        }
      },
      {
        path: "wishlist",
        name: "Wishlist",
        component: indexWishlist,
        meta: {
          title: 'Wish List | Coin - Premium Admin Template',
        }
      },
      {
        path: "order_history",
        name: "Orderhistory",
        component: indexOrder
      },
      {
        path: "productlist",
        name: "productlist",
        component: indexProductlist,
        meta: {
          title: 'Product list | Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/gallery",
    component: BodyView,
    children: [
      {
        path: "grid_gallery",
        name: "Gallerygrid",
        component: indexGallery,
        meta: {
          title: 'Grid Gallery | Coin - Premium Admin Template',
        }
      },
      {
        path: "gallery_desc",
        name: "griddesc",
        component: indexGriddesc,
        meta: {
          title: 'Grid Gallery With Desc | Coin - Premium Admin Template',
        }
      },
      {
        path: "gallery_masonary",
        name: "Masonry",
        component: indexMasonry,
        meta: {
          title: 'Masonry | Coin - Premium Admin Template',
        }
      },
      {
        path: "gallery_masonary_desc",
        name: "Masonarydesc",
        component: indexMasonarydesc,
        meta: {
          title: 'Masonry Desc| Coin - Premium Admin Template',
        }
      },
      {
        path: "hover_effect",
        name: "hovergallery",
        component: hoverGallery,
        meta: {
          title: 'Hover Gallery| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/blog",
    component: BodyView,
    children: [
      {
        path: "details",
        name: "blogdetails",
        component: indexDetails,
        meta: {
          title: 'Blog Details| Coin - Premium Admin Template',
        }
      },
      {
        path: "single",
        name: "blogsingle",
        component: indexSingle,
        meta: {
          title: 'Blog Single| Coin - Premium Admin Template',
        }
      },
      {
        path: "add_post",
        name: "addpost",
        component: indexAdd,
        meta: {
          title: 'Add Post| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/job",
    component: BodyView,
    children: [
      {
        path: "card",
        name: "jobcard",
        component: jobCard,
        meta: {
          title: 'Job Card| Coin - Premium Admin Template',
        }
      },
      {
        path: "/job/details/:id",
        name: "jobdetails",
        component: indexJobdetails,
        props: true,
        meta: {
          title: 'Job Details| Coin - Premium Admin Template',
        }
      },
      {
        path: "apply/:id",
        name: "jobapply",
        component: indexApply,
        meta: {
          title: 'Job Apply| Coin - Premium Admin Template',
        }
      },
      {
        path: "list",
        name: "joblist",
        component: indexList,
        meta: {
          title: 'Job List| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/learning",
    component: BodyView,
    children: [
      {
        path: "list",
        name: "Learninglist",
        component: indexLearning,
        meta: {
          title: 'Learning List| Coin - Premium Admin Template',
        }
      },
      {
        path: "details/:id",
        name: "coursedetailed",
        component: indexCourse,
        meta: {
          title: 'course Detailed| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/maps",
    component: BodyView,
    children: [
      {
        path: "vue_google_maps",
        name: "googlemaps",
        component: indexGooglemap,
        meta: {
          title: 'Google Map| Coin - Premium Admin Template',
        }
      },
      {
        path: "vue_leaflet_maps",
        name: "mapLeaflet",
        component: indexLeaflet,
        meta: {
          title: 'Leaflet Map| Coin - Premium Admin Template',
        }
      },

    ]
  },
  {
    path: "/editor",
    component: BodyView,
    children: [
      {
        path: "simple_editor",
        name: "simpleEditor",
        component: simpleEditor,
        meta: {
          title: 'Simple Editor| Coin - Premium Admin Template',
        }
      },
      {
        path: "ck_editor",
        name: "ckeditor",
        component: indexCk,
        meta: {
          title: 'Ck Editor| Coin - Premium Admin Template',
        }
      }
    ]
  },
  {
    path: "/knowledgebase",
    component: BodyView,
    children: [
      {
        path: "knowledgebase",
        name: "Knowledgebase",
        component: indexKnowledgebase,
        meta: {
          title: 'Knowledgebase| Coin - Premium Admin Template',
        }
      },

    ]
  },
  {
    path: "/error_page1",
    name: "errorPage1",
    component: errorPage1,
    meta: {
      title: 'Error Page1| Coin - Premium Admin Template',
    }
  },
  {
    path: "/error_page2",
    name: "errorPage2",
    component: errorPage2,
    meta: {
      title: 'Error Page2| Coin - Premium Admin Template',
    }
  },
  {
    path: "/error_page3",
    name: "errorPage3",
    component: errorPage3,
    meta: {
      title: 'Error Page3| Coin - Premium Admin Template',
    }
  },
  {
    path: "/error_page4",
    name: "errorPage4",
    component: errorPage4,
    meta: {
      title: 'Error Page4| Coin - Premium Admin Template',
    }
  },
  {
    path: "/error_page5",
    name: "errorPage5",
    component: errorPage5,
    meta: {
      title: 'Error Page5| Coin - Premium Admin Template',
    }
  },
  {
    path: "/error_page6",
    name: "errorPage6",
    component: errorPage6,
    meta: {
      title: 'Error Page6| Coin - Premium Admin Template',
    }
  },
  {
    path: "/comingsoon/comingsoon_simple",
    name: "comingsoonPage",
    component: comingsoonPage
  },
  {
    path: "/comingsoon/comingsoon_video",
    name: "comingsoonVideo",
    component: comingsoonVideo
  },
  {
    path: "/comingsoon/comingsoon_image",
    name: "comingsoonImage",
    component: comingsoonImage
  },
  {
    path: "/comingsoon/comingsoon_simple",
    name: "comingsoonPage",
    component: comingsoonPage
  },
  {
    path: "/comingsoon/comingsoon_video",
    name: "comingsoonVideo",
    component: comingsoonVideo
  },
  {
    path: "/comingsoon/comingsoon_image",
    name: "comingsoonImage",
    component: comingsoonImage
  },
  {
    path: "/authentication/simple",
    name: "loginsimple",
    component: loginSimple
  },
  {
    path: "/authentication/login/one",
    name: "loginimage",
    component: loginImage
  },
  {
    path: "/authentication/login/two",
    name: "loginImagetwo",
    component: loginImagetwo
  },
  {
    path: "/authentication/login/validate",
    name: "loginValidation",
    component: loginValidation
  },
  {
    path: "/authentication/login/tooltip",
    name: "loginTooltip",
    component: loginTooltip
  },
  {
    path: "/authentication/login/sweetalert",
    name: "loginSweetalert",
    component: loginSweetalert
  },
  {
    path: "/authentication/register/two",
    name: "registerImagetwo",
    component: registerImagetwo
  },
  {
    path: "/auth/register",
    name: "registerSimple",
    component: registerSimple
  },
  {
    path: "/authentication/register/one",
    name: "registerImage",
    component: registerImage
  },
  {
    path: "/authentication/unlock_user",
    name: "unlockUser",
    component: unlockUser
  },
  {
    path: "/authentication/forget_password",
    name: "forgetPassword",
    component: forgetPassword
  },
  {
    path: "/authentication/reset_password",
    name: "resetPassword",
    component: resetPassword
  },
  {
    path: "/authentication/maintenance",
    name: "maintenanceView",
    component: maintenanceView
  },
  {
    path: "/email",
    component: BodyView,
    children: [
      {
        path: "email_app",
        name: "emailapp",
        component: indexEmailapp
      },

      {
        path: "email_compose",
        name: "emailCompose",
        component: indexCompose
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (typeof (to.meta.title) === 'string') {
    document.title = to.meta.title;
  }
  const path = ['/auth/login', '/auth/register'];
  if (path.includes(to.path) || localStorage.getItem('user')) {
    return next();
  }
  next('/auth/login');
});

export default router
